import { Panne } from "@/types";
import { getData, postData, putData, deleteData } from "./axios-service"

function modelMapper(inputPanne: any): Panne {
    return {
        id: inputPanne.id,
        date: inputPanne.date,
        name: inputPanne.name,
        desc: inputPanne.desc,
        technicien: inputPanne.technicien,
        createTask: inputPanne.createTask
    };
}

export function modelMapperArray(inputArray: any[]): Panne[] {
    return inputArray.map(modelMapper);
}

export async function getPanneByProduct(productId: string): Promise<Panne[]> {
    const pannes = await getData<Panne[]>("products/" + productId + "/pannes");
    return modelMapperArray(pannes ?? []);
}

export function getPanneById(panneId: string): Promise<Panne> {
    return getData("pannes/" + panneId).then(
        onSucceed => {
            return modelMapper(onSucceed);
        }
    );
}

export function postPanne(panne: Panne, productId: string): Promise<Panne> {
    return postData("products/" + productId + "/pannes", panne).then(
        onSucceed => {
            return modelMapper(onSucceed);
        }
    );
}

export function putPanne(panne: Panne): Promise<any> {
    return putData("pannes/" + panne.id, panne)
}

export function deletePanne(panneId: string): Promise<any> {
    return deleteData("pannes/" + panneId)
}